const bizNumberValidator = (value) => {
  const checkPath = value || ''
  const checkId = [1, 3, 7, 1, 3, 7, 1, 3, 5, 1]
  let chkSum = 0
  let c2

  for (let i = 0; i <= 7; i += 1) {
    chkSum += checkId[i] * Number(checkPath.charAt(i))
  }
  c2 = `0${checkId[8] * Number(checkPath.charAt(8))}`
  c2 = c2.substring(c2.length - 2, c2.length)
  chkSum += Math.floor(Number(c2.charAt(0))) + Math.floor(Number(c2.charAt(1)))
  return (
    Math.floor(Number(checkPath.charAt(9))) === (10 - (chkSum % 10)) % 10 &&
    checkPath.length === 10
  )
}

export default bizNumberValidator
